import { useTitrePage } from '@/lib/titre-page';
import { PageLayout } from '@pms-digital/design-system';
import type { ReactNode } from 'react';

interface CadreAnalyseProps {
  /** What the page is, for the title of the tab: each state of the screen says its own. */
  titre: string;
  children: ReactNode;
}

/** The page of the analysis: the page of the package, « default » (1 200 px), margins of the charter. */
export function CadreAnalyse({ titre, children }: CadreAnalyseProps) {
  useTitrePage(titre);
  return <PageLayout width="default">{children}</PageLayout>;
}
